import { Component, OnInit, Inject, TemplateRef, ViewChild, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { is } from 'date-fns/locale';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-checklist-dialog',
  templateUrl: './checklist-dialog.component.html',
  styleUrls: ['./checklist-dialog.component.scss']
})
export class ChecklistDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('displayGroupModal') private displayGroupModal!: TemplateRef<any>;

  @ViewChild('displayDropDownModal') private displayDropDownModal!: TemplateRef<any>;

  @ViewChildren(MatPaginator) paginator1 = new QueryList<MatPaginator>();

  @ViewChildren(MatSort) sort1 = new QueryList<MatSort>();

  isAccess = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_ACCESS;

  isWrite = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_CREATE;

  isUpdate = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_UPDATE;

  isDelete = ApplicationPermission.PREVENTIVE_MAINTANANCE_CONFIGURATION_DELETE;

  AddGroupForm!: FormGroup;

  GroupAdded: string[] = [];

  CheckListRowData!: FormGroup;

  addtabledata: any[] = [];

  checklistTempData: any[] = [];

  counter = 1;

  goodImgArray: File[] = [];

  badImgArray: File[] = [];

  CheckListAddModel!: MatTableDataSource<any>;

  tableIndex: any;

  adddropdowndata: Array<any> = [];

  taskId: any;

  DropdownElemenet !: MatTableDataSource<any>;

  itemName: string = '';

  tempArray = [];

  curentrowId: any;

  drop: string = '';

  itemType!: any;

  images: any[] = [];

  doc: any;

  displayMaximizable: boolean = false;

  fileSave!: File;

  itemColumns: string[] = [
    'itemActions',
    'items',
    'ListName',
    'ItemType',
    'standard',
    'minimum',
    'maximum',
    'good',
    'bad',
  ];

  DropDownAdded!: any[];

  items!: any[];

  ItemType: any;

  isLoading: boolean = false;

  AddDropDownForm!: FormGroup;

  checkListdetailId: any;

  displayedColumns: string[] = ['index', 'value', 'Action'];

  formMode!: boolean;

  fileType: any;

  displayGroupDialogRef: MatDialogRef<any>;

  displayDropDownDialogRef: MatDialogRef<any>;

  plantSession: any;

  groupSession: any;

  user: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  parentData: any;

  blobUrl: string = environment.blobStorageUrl;

  imageIndexOne = 0;

  constructor
    (
      public dialogRef: MatDialogRef<ChecklistDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialog: MatDialog,
      private translater: TranslaterService,
      private translate: TranslateService,
      private toaster: ToastrService,
      private fb: FormBuilder,
      private prevConfigurationService: PrevConfigurationService,
      private spinner: NgxSpinnerService,
      private baseApi: BaseApi,
    ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
  }

  ngOnInit() {
    this.getSessionData();
    this.getLangWords();
    this.initializeCheckListForms();
    this.getItemType();
    
    this.formMode = true;
  }

  getParentData(): void {
    this.parentData = this.data;
    this.taskId = this.data.ID;
    if (this.taskId) {
      this.getChecklistDataById(this.taskId);
    }
  }
  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      // if (this.langObj) {
      //   this.gridApi.refreshHeader();
      // }
    });
  }
  getChecklistDataById(id: number): void {
    this.spinner.show();
    this.prevConfigurationService.GetCheckListByTaskId(id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.Checklist.length > 0) {
          this.GroupAdded = res.GroupNames || [];
          this.formMode = false;

          const filtered = res.Checklist.filter(item => item.IsActive === true && item.IsDeleted === false);

          this.addtabledata = filtered.map(item => ({
            id: item.Id,
            item: item.Item,
            itemtype: item.ItemType,
            drop: item.GroupName,
            goodImage: item.GoodImage,
            badImage: item.BadImage,
            dropDown: item.DropDown,
            taskId: item.TaskId ?? 0,
            badExampleImageName: item.BadExampleImageName || '',
            goodExampleImageName: item.GoodExampleImageName || '',
            standard: item.Standard || '',
            minValue: item.Min ?? null,
            maxValue: item.Max ?? null,
            displaybtn: item.ItemType === 5,
            HideViewIcon: false,
            HideViewIcon1: false,
            isActive: item.IsActive,
            isDeleted: item.IsDeleted
          }));

          this.checklistTempData = [...this.addtabledata];
          this.CheckListAddModel = new MatTableDataSource<any>(this.addtabledata);
          this.getPaginatorForSecond(this.CheckListAddModel, 0);


        } else {
          this.formMode = true;
          this.addTable();
        }
      },
      error: (error) => {
        this.spinner.hide();
        const errMsg = error?.error?.message || 'An error occurred while fetching checklist data.';
        this.toaster.error(errMsg);
      }
    });
  }





  ngAfterViewInit(): void {
    this.popupMaxIndex();
  }

  addGroupModal(): void {
    this.displayGroupDialogRef = this.dialog.open(this.displayGroupModal, {
      height: '31%',
      width: '40%',
      disableClose: true,
    });
    this.popupMaxIndex();
    this.AddGroupForm.reset();
  }

  popupMaxIndex(): void {
    setTimeout(() => {
      var overlayEl = document.getElementsByClassName('cdk-overlay-container');
      for (var i = 0; i < overlayEl.length; i++) {

        (overlayEl[i] as HTMLElement).style.zIndex = '500';
      }
    }, 50);
  }

  closeDisplayGroupModal() {
    if (this.displayGroupDialogRef) {
      this.displayGroupDialogRef.close();
    }
  }

  SaveGroup(): void {
    const key = this.AddGroupForm.get('dropname')?.value;
    if (!this.GroupAdded.includes(key.replace(/\s+/g, ''))) {
      this.GroupAdded.push(key);
      this.toaster.success('Group added successfully');
    }
    else {
      this.toaster.warning('Group already exist')
    }
    this.AddGroupForm.reset();
  }

  initializeCheckListForms(): void {

    this.AddGroupForm = this.fb.group({
      dropname: ['', Validators.required],
    });

    this.CheckListRowData = this.fb.group({
      itemName: [''],
      goodExample: [],
      standard: [],
      badExample: [''],
      itemGroup: [''],
      itemType: [''],
    });

    this.AddDropDownForm = this.fb.group({
      dropdown: ['', Validators.required]
    })
  }

  addTable(): void {
    // Validate existing rows
    if (this.addtabledata.length > 0) {
      const chkItem = this.addtabledata.find((x) => x.item === '');
      const chkGroup = this.addtabledata.find((x) => x.drop === '');
      const chkType = this.addtabledata.find((x) => x.itemtype === 0);

      if (chkGroup && chkItem && chkType) {
        this.toaster.error('Please Add Group, Item and Itemtype');
        return;
      } else if (chkGroup) {
        this.toaster.error('Please Add Group');
        return;
      } else if (chkItem) {
        this.toaster.error('Please Add Item');
        return;
      } else if (chkType) {
        this.toaster.error('Please Add Item Type');
        return;
      }
    }

    // New row structure
    const row = {
      id: 0,
      tempId: this.counter,
      item: this.CheckListRowData.value.itemName,
      itemtype: this.ItemType[0].itemTypeId,
      GroupName: this.CheckListRowData.value.itemGroup,
      standard: this.CheckListRowData.value.standard,
      taskId: 0,
      goodImage: '',
      badImage: '',
      goodExampleImageName: '',
      badExampleImageName: '',
      dropDown: [],
      IsDeleted: false,
      isActive: true // default to true
    };

    const f = new File([''], 'filename');

    this.addtabledata.push(row);
    this.goodImgArray.push(f);
    this.badImgArray.push(f);

    // Only show rows where isActive is true and IsDeleted is false
    const visibleRows = this.addtabledata.filter(x => x.isActive && !x.IsDeleted);
    this.CheckListAddModel = new MatTableDataSource<any>(visibleRows);
    this.getPaginatorForSecond(this.CheckListAddModel, 4);

    this.counter = this.counter + 1;
  }



  deleteRow(element: any, index: number): void {
    let removedTempId = null;

    for (let i = 0; i < this.addtabledata.length; i++) {
      const currentItem = this.addtabledata[i];

      // Check by tempId if it exists
      if (element.tempId && currentItem.tempId === element.tempId) {
        removedTempId = currentItem.tempId;
        this.addtabledata.splice(i, 1);
        break;
      }

      // If no tempId, check by id
      if (!element.tempId && currentItem.id === element.id) {
        if (currentItem.id === 0) {
          this.addtabledata.splice(i, 1);
        } else {
          this.addtabledata[i].isActive = false;
          this.addtabledata[i].isDeleted = true;
        }
        removedTempId = currentItem.tempId || null;
        break;
      }
    }

    if (removedTempId !== null) {
      const tempIndex = this.tempArray.findIndex(x => x.Index === removedTempId);
      if (tempIndex !== -1) {
        this.tempArray.splice(tempIndex, 1);
      }
    }

    // Refresh the visible table
    const visibleData = this.addtabledata.filter(item => item.isActive !== false && item.isDeleted !== true);
    this.CheckListAddModel = new MatTableDataSource<any>(visibleData);
    this.getPaginatorForSecond(this.CheckListAddModel, 0);
  }





  getPaginatorForSecond(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      data.paginator = this.paginator1.toArray()[index];
      data.sort = this.sort1.toArray()[index];
    }, 1000);
  }

  addDropDownModal(element: any, i: number): void {
    this.tableIndex = i;
    this.adddropdowndata = [];
    this.checkListdetailId = element.id;
    this.curentrowId = element.tempId ? element.tempId : element.id;

    if (this.formMode) {
      this.checkListdetailId = 0;

      const dropdownList = this.addtabledata[i]?.dropDown || [];
      this.adddropdowndata = [...dropdownList];

      const filteredDropDowns = this.adddropdowndata.filter(d => d.IsActive !== false && d.IsDeleted !== true);
      this.DropdownElemenet = new MatTableDataSource<any>(filteredDropDowns);

      this.displayDropDownDialogRef = this.dialog.open(this.displayDropDownModal, {
        height: 'auto',
        width: '60%',
        maxHeight: '90vh',
        disableClose: true
      });

      this.popupMaxIndex();
    } else {
      if (element.id !== 0) {
        // Real saved checklist (future use: API call)
        this.getDropdown(element);
      } else {
        // ✅ Only use dropdowns saved for *this* unsaved row (via tempArray)
        const notSaved = this.tempArray.find(obj => obj.Index === i);

        if (notSaved) {
          if (element.dropDown && element.dropDown.length > 0) {
            this.adddropdowndata = [...notSaved.arrayData];
          } else {
            this.adddropdowndata = []; // important: reset for truly new checklist
          }
        }

        const filteredDropDowns = this.adddropdowndata.filter(d => d.IsActive !== false && d.IsDeleted !== true);
        this.DropdownElemenet = new MatTableDataSource<any>(filteredDropDowns);
      }

      this.displayDropDownDialogRef = this.dialog.open(this.displayDropDownModal, {
        width: '60%',
        height: 'auto',
        disableClose: true
      });

      this.popupMaxIndex();

      this.displayDropDownDialogRef.afterClosed().subscribe(() => {
        const updatedObj = {
          Index: this.tableIndex,
          arrayData: [...this.adddropdowndata]
        };

        const index = this.tempArray.findIndex(x => x.Index === this.tableIndex);
        if (index !== -1) {
          this.tempArray.splice(index, 1);
        }

        this.tempArray.push(updatedObj);
      });
    }
  }




  closeDisplayDropDownModal() {
    if (this.displayDropDownDialogRef) {
      this.displayDropDownDialogRef.close();
    }
  }

  getDropdown(element: any): void {
    if (element?.dropDown && element.dropDown.length > 0) {
      const dropdownData = [...element.dropDown];
      this.adddropdowndata = dropdownData.map(item => ({
        ...item,
        value: item.Value ? item.Value : item.value,
      }));
      this.DropdownElemenet = new MatTableDataSource<any>(this.adddropdowndata);
    }
  }



  columnEvent(event: any, data: any): void {
    this.itemName = event.target.value;

    for (let i = 0; i < this.addtabledata.length; i++) {
      const currentItem = this.addtabledata[i];

      if (data.tempId && currentItem.tempId === data.tempId) {
        this.addtabledata[i].item = event.target.value;
        break;
      }

      if (!data.tempId && currentItem.id === data.id) {
        this.addtabledata[i].item = event.target.value;
        break;
      }
    }
  }


  columnGroupEvent(event: any, data: any): void {
    this.drop = event.value;

    for (let i = 0; i < this.addtabledata.length; i++) {
      const currentItem = this.addtabledata[i];

      if (data.tempId && currentItem.tempId === data.tempId) {
        this.addtabledata[i].drop = event.value;
        break;
      }

      if (!data.tempId && currentItem.id === data.id) {
        this.addtabledata[i].drop = event.value;
        break;
      }
    }
  }


  columnItemEvent(event: any, data: any, i: number): void {
    this.itemType = event.value;

    const compareId = data.tempId ?? data.id;

    if (event.value === 5) {
      this.addtabledata[i].minValue = null;
      this.addtabledata[i].maxValue = null;

      this.CheckListAddModel.data.forEach((elem, index) => {
        const elemCompareId = elem.tempId ?? elem.id;
        if (elemCompareId === compareId) {
          this.CheckListAddModel.data[index].displaybtn = true;
          this.CheckListAddModel = new MatTableDataSource<any>(this.CheckListAddModel.data);
          this.getPaginatorForSecond(this.CheckListAddModel, 0);
        }
      });
    } else {
      this.addtabledata[i].minValue = null;
      this.addtabledata[i].maxValue = null;

      this.CheckListAddModel.data.forEach((elem, index) => {
        const elemCompareId = elem.tempId ?? elem.id;
        if (elemCompareId === compareId) {
          this.CheckListAddModel.data[index].displaybtn = false;
          this.CheckListAddModel = new MatTableDataSource<any>(this.CheckListAddModel.data);
          this.getPaginatorForSecond(this.CheckListAddModel, 0);
        }
      });
    }

    for (let i = 0; i < this.addtabledata.length; i++) {
      const currentCompareId = this.addtabledata[i].tempId ?? this.addtabledata[i].id;
      if (currentCompareId === compareId) {
        this.addtabledata[i].itemtype = event.value;
      }
    }
  }


  openFilePopUp(elem: any, index: number, n: number): void {
    const elementIndex = this.addtabledata.findIndex(
      (data) => data.id === elem.id
    );

    this.images = [];
    if (n === 1) {
      const array = elem.goodExampleImageName.split('.');
      const fileType = array[array.length - 1];
      this.doc = this.blobUrl + elem.goodExampleImageName;
      if (fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif' || fileType == 'webp' || fileType == 'tiff' || fileType == 'bmp' || fileType == 'eps' || fileType == 'svg' || fileType == 'jfif') {
        this.images = [];
        this.fileType = 'img';
        this.images.push(this.doc);
      }
      else {
        this.fileType = 'doc';
        this.images.push(this.doc);
      }
      this.displayMaximizable = true;
    }
    else if (n === 2) {
      const array = elem.badExampleImageName.split('.');
      const fileType = array[array.length - 1];
      this.doc = this.blobUrl + elem.badExampleImageName;
      if (fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' || fileType === 'gif' || fileType == 'webp' || fileType == 'tiff' || fileType == 'bmp' || fileType == 'eps' || fileType == 'svg' || fileType == 'jfif') {
        this.images = [];
        this.fileType = 'img';
        this.images.push(this.doc);
      } else {
        this.fileType = 'doc';
        this.images.push(this.doc);
      }
      this.displayMaximizable = true;
      setTimeout(() => {
        var el = document.getElementById("ngx-fs-btn") as HTMLElement;
        el.style.border = 'none';
        el.style.marginTop = "0.3rem";
      }, 500);
    }
  }

  setFileInputUI(event: any, fileInput: any): void {
    const fileInputId = fileInput?.id;
    const matFormField = document.querySelector(`#${fileInputId}`).closest('mat-form-field');
    const fileInputSpan = document.querySelector(`#${fileInputId} .filename`);

    if (matFormField && !matFormField.classList.contains('mat-form-field-should-float')) {
      matFormField.classList.add('mat-form-field-should-float');
    }

    if (fileInputSpan) {
      (fileInputSpan as HTMLElement).textContent = event.target.files[0].name;
    }
  }


  uploadedFile(event: any, element: any, fileInput: any): void {

    const isValid = this.validateFileSizeAndUpdateUI(event, element, fileInput, 'goodImage');
    if (!isValid) return;

    this.setFileInputUI(event, fileInput);

    const elementIndex = this.addtabledata.findIndex(data =>
      element.tempId ? data.tempId === element.tempId : data.id === element.id
    );
    if (elementIndex !== -1 && event.target.files.length > 0) {
      const file = event.target.files[0];

      this.addtabledata[elementIndex].goodExampleImageName = file.name;
      this.addtabledata[elementIndex].goodImage = file;
      this.goodImgArray[elementIndex] = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e: any) => {
        this.addtabledata[elementIndex].goodImagePreview = e.target.result;
      };

      this.addtabledata[elementIndex].HideViewIcon = true;
    }
  }

  validateFileSizeAndUpdateUI(event: any, element: any, fileInput: any, type: string): boolean {
    const maxSizeInMB = 5;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    const elementIndex = this.addtabledata.findIndex(data =>
      element.tempId ? data.tempId === element.tempId : data.id === element.id
    );
    if (elementIndex !== -1 && event.target.files.length > 0) {
      if (type === 'goodImage') {
        this.addtabledata[elementIndex].goodExampleImageName = null;
        this.addtabledata[elementIndex].goodImage = null;
        this.addtabledata[elementIndex].goodImagePreview = null;
      }
      else if (type === 'badImage') {
        this.addtabledata[elementIndex].badExampleImageName = null;
        this.addtabledata[elementIndex].badImage = null;
        this.addtabledata[elementIndex].badImagePreview = null;
      }
    }

    const selectedFile = event.target.files[0];
    if (selectedFile.size > maxSizeInBytes) {
      this.toaster.warning('File size exceeds 5MB limit. Please upload a smaller file.');

      event.target.value = '';

      const fileInputId = fileInput?.id;
      const fileinputdiv = document.querySelector(`#${fileInputId}`).closest('div');
      const matFormField = document.querySelector(`#${fileInputId}`).closest('mat-form-field');
      const fileInputSpan = document.querySelector(`#${fileInputId} .filename`);
      if (fileInputSpan) {
        (fileInputSpan as HTMLElement).textContent = '';
      }

      if (matFormField && matFormField.classList.contains('mat-form-field-should-float')) {
        matFormField.classList.remove('mat-form-field-should-float');
      }

      const labelWrapperSpan = fileinputdiv?.querySelector('.mat-form-field-label-wrapper');
      const labelElement = labelWrapperSpan?.querySelector('label') as HTMLElement;
      if (labelElement) {
        labelElement.style.display = 'flex';
        labelElement.classList.remove('mat-empty', 'mat-form-field-empty');
      }

      return false;
    }

    return true;
  }



  uploadedFile2(event: any, element: any, fileInput: any): void {

    const isValid = this.validateFileSizeAndUpdateUI(event, element, fileInput, 'badImage');
    if (!isValid) return;

    const elementIndex = this.addtabledata.findIndex(data =>
      element.tempId ? data.tempId === element.tempId : data.id === element.id
    );

    if (elementIndex !== -1 && event.target.files.length > 0) {
      const file = event.target.files[0];

      this.addtabledata[elementIndex].badExampleImageName = file.name;
      this.addtabledata[elementIndex].badImage = file;
      this.badImgArray[elementIndex] = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e: any) => {
        this.addtabledata[elementIndex].badImagePreview = e.target.result;
      };

      this.addtabledata[elementIndex].HideViewIcon1 = true;
    }
  }



  addCheckList(): any {
    this.spinner.show();

    if (this.addtabledata.length === 0) {
      this.spinner.hide();
      this.toaster.error('Fill Data Correctly');
      return;
    }

    const chkItem = this.addtabledata.find(x => x.item === '');
    const chkGroup = this.addtabledata.find(x => x.drop === '');
    const chkType = this.addtabledata.find(x => x.itemtype === 0);

    if (chkGroup || chkItem || chkType) {
      this.spinner.hide();
      const error = chkGroup ? 'Group' : chkItem ? 'Item' : 'Item Type';
      this.toaster.error(`Please Add ${error}`);
      return;
    }

    const formData = new FormData();
    this.addtabledata.forEach((checklist, index) => {
      formData.append(`checklists[${index}].Id`, checklist.id);
      formData.append(`checklists[${index}].Item`, checklist.item);
      formData.append(`checklists[${index}].ItemType`, checklist.itemtype);
      formData.append(`checklists[${index}].GroupName`, checklist.drop);

      if (checklist.goodImage) {
        formData.append(`checklists[${index}].GoodImage`, checklist.goodImage, checklist.goodImage.name);
      }

      if (checklist.badImage) {
        formData.append(`checklists[${index}].BadImage`, checklist.badImage, checklist.badImage.name);
      }

      formData.append(`checklists[${index}].Standard`, checklist.standard || '');
      formData.append(`checklists[${index}].Min`, checklist.minValue);
      formData.append(`checklists[${index}].Max`, checklist.maxValue);
      formData.append(`checklists[${index}].TaskId`, this.taskId);
      formData.append(`checklists[${index}].PlantCode`, this.plantSession.plantCode || '');
      formData.append(`checklists[${index}].GroupCode`, this.groupSession.groupCode || '');
      formData.append(`checklists[${index}].UserCode`, this.user.userCode || '');

      (checklist.dropDown || []).forEach((dropdown, dIndex) => {
        formData.append(`checklists[${index}].DropDown[${dIndex}].id`, dropdown.id);
        formData.append(`checklists[${index}].DropDown[${dIndex}].value`, dropdown.value);
        formData.append(`checklists[${index}].DropDown[${dIndex}].PlantCode`, dropdown.PlantCode);
        formData.append(`checklists[${index}].DropDown[${dIndex}].groupCode`, dropdown.groupCode ? dropdown.groupCode : dropdown.GroupCode);
        formData.append(`checklists[${index}].DropDown[${dIndex}].UserCode`, dropdown.UserCode);
        formData.append(`checklists[${index}].DropDown[${dIndex}].checklistId`, '0');
      });
    });
    this.prevConfigurationService.AddCheckListsByTaskId(formData).subscribe({
      next: (res) => {
        this.spinner.hide();
        this.toaster.success('Checklist saved successfully!');
        this.dialog.closeAll();
        this.getChecklistDataById(this.taskId);
      },
      error: (err) => {
        this.spinner.hide();
        this.toaster.error(err?.error?.message || 'Something went wrong!');
      }
    });

  }

  updateCheckList(): any {
    this.spinner.show();

    if (this.addtabledata.length === 0) {
      this.spinner.hide();
      this.toaster.error('Fill Data Correctly');
      return;
    }

    const chkItem = this.addtabledata.find(x => x.item === '');
    const chkGroup = this.addtabledata.find(x => x.drop === '');
    const chkType = this.addtabledata.find(x => x.itemtype === 0);

    if (chkGroup || chkItem || chkType) {
      this.spinner.hide();
      const error = chkGroup ? 'Group' : chkItem ? 'Item' : 'Item Type';
      this.toaster.error(`Please Add ${error}`);
      return;
    }

    const formData = new FormData();
    this.addtabledata.forEach((checklist, index) => {
      formData.append(`checklists[${index}].Id`, checklist.id);
      formData.append(`checklists[${index}].Item`, checklist.item);
      formData.append(`checklists[${index}].ItemType`, checklist.itemtype);
      formData.append(`checklists[${index}].GroupName`, checklist.drop);

      if (checklist.goodImage) {
        formData.append(`checklists[${index}].GoodImage`, checklist.goodImage, checklist.goodImage.name);
      }

      if (checklist.badImage) {
        formData.append(`checklists[${index}].BadImage`, checklist.badImage, checklist.badImage.name);
      }

      formData.append(`checklists[${index}].Standard`, checklist.standard || '');
      formData.append(`checklists[${index}].Min`, checklist.minValue);
      formData.append(`checklists[${index}].Max`, checklist.maxValue);
      formData.append(`checklists[${index}].TaskId`, this.taskId);
      formData.append(`checklists[${index}].IsActive`, checklist.isActive);
      formData.append(`checklists[${index}].IsDeleted`, checklist.isDeleted);
      formData.append(`checklists[${index}].PlantCode`, this.plantSession.plantCode || '');
      formData.append(`checklists[${index}].GroupCode`, this.groupSession.groupCode || '');
      formData.append(`checklists[${index}].UserCode`, this.user.userCode || '');

      (checklist.dropDown || []).forEach((dropdown, dIndex) => {
        formData.append(`checklists[${index}].DropDown[${dIndex}].Id`, dropdown.Id ? dropdown.Id : 0);
        formData.append(`checklists[${index}].DropDown[${dIndex}].Value`, dropdown.value ? dropdown.value : dropdown.Value);
        formData.append(`checklists[${index}].DropDown[${dIndex}].PlantCode`, dropdown.PlantCode);
        formData.append(`checklists[${index}].DropDown[${dIndex}].GroupCode`, dropdown.GroupCode);
        formData.append(`checklists[${index}].DropDown[${dIndex}].UserCode`, dropdown.UserCode);
        formData.append(`checklists[${index}].DropDown[${dIndex}].IsActive`, dropdown.IsActive);
        formData.append(`checklists[${index}].DropDown[${dIndex}].IsDeleted`, dropdown.IsDeleted);
        formData.append(`checklists[${index}].DropDown[${dIndex}].ChecklistId`, dropdown.ChecklistId ? dropdown.ChecklistId : '0');
      });
    });

    this.prevConfigurationService.UpdateCheckListsByTaskId(formData).subscribe({
      next: (res) => {
        this.spinner.hide();
        this.toaster.success('Checklist Updated successfully!');
        this.dialog.closeAll();
        this.getChecklistDataById(this.taskId);
      },
      error: (err) => {
        this.spinner.hide();
        this.toaster.error(err?.error?.message || 'Something went wrong!');
      }
    });
  }


  getItemType(): any {
    this.spinner.show();
    this.prevConfigurationService.getItemTypes().subscribe(
      (areadata: any) => {
        this.spinner.hide();
        this.items = areadata;
        this.ItemType = this.items.slice();
        this.getParentData();
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(error.error.message);
        this.spinner.hide();
      }
    );
  }

  SaveDropDown(): void {
    const key = {
      Id: 0,
      value: this.AddDropDownForm.get('dropdown')?.value,
      Value: this.AddDropDownForm.get('dropdown')?.value,
      PlantCode: this.plantSession.plantCode,
      GroupCode: this.groupSession.groupCode,
      UserCode: this.user.userCode,
      IsActive: true,
      IsDeleted: false,
      ChecklistId: this.checkListdetailId ? this.checkListdetailId : 0
    };

    const trimmedValue = key.value.replace(/\s+/g, '').toLowerCase();
    const isDuplicate = this.adddropdowndata.some(el =>
      el.value.replace(/\s+/g, '').toLowerCase() === trimmedValue &&
      el.IsDeleted !== true &&
      el.IsActive !== false
    );

    if (!isDuplicate) {
      let index = this.addtabledata.findIndex(item => item.id === this.curentrowId);
      if (index === -1) {
        index = this.addtabledata.findIndex(item => item.tempId === this.curentrowId);
      }

      if (index !== -1) {
        this.adddropdowndata.push(key);
        this.addtabledata[index].dropDown.push(key);
        this.toaster.success('Element added successfully');
      } else {
        this.toaster.error('Row not found for dropdown addition');
      }
    } else {
      this.toaster.warning('Value should not be duplicated');
    }

    const filtered = this.adddropdowndata.filter(d => d.IsActive !== false && d.IsDeleted !== true);
    this.DropdownElemenet = new MatTableDataSource<any>(filtered);

    this.AddDropDownForm.reset();
  }






  deletedropDownById(data, i): void {
    if (data.id === 0 || (data.id !== 0 && data.tempId)) {
      this.adddropdowndata.splice(i, 1);
    } else {
      this.adddropdowndata[i].IsActive = false;
      this.adddropdowndata[i].IsDeleted = true;
    }

    this.DropdownElemenet = new MatTableDataSource<any>(this.adddropdowndata);

    const tableRowIndex = this.addtabledata.findIndex(item =>
      item.id === this.curentrowId || item.tempId === this.curentrowId
    );
    if (tableRowIndex !== -1) {
      this.addtabledata[tableRowIndex].dropDown = [...this.adddropdowndata];
    }

    const tempIndex = this.tempArray.findIndex(x => x.Index === this.tableIndex);
    if (tempIndex !== -1) {
      this.tempArray[tempIndex].arrayData = [...this.adddropdowndata];
    }
  }

  minEvent(event: any, data: any, i: number): void {
    const compareId = data.tempId ?? data.id;
    let val = event.target.value;
    let floatNum = parseFloat(val).toFixed(2);
    let num;
    if (floatNum.toString().split('.')[1] == '0') {
      num = parseInt(floatNum);
    }
    else {
      num = parseFloat(val);
    }

    for (let i = 0; i < this.addtabledata.length; i++) {
      const currentCompareId = this.addtabledata[i].tempId ?? this.addtabledata[i].id;
      if (currentCompareId === compareId) {
        this.addtabledata[i].minValue = num;
      }
    }
  }

  maxEvent(event: any, data: any, i: number): void {
    const compareId = data.tempId ?? data.id;

    let val = event.target.value;
    let floatNum = parseFloat(val).toFixed(2);
    let num;
    if (floatNum.toString().split('.')[1] == '0') {
      num = parseInt(floatNum);
    }
    else {
      num = parseFloat(val);
    }

    for (let i = 0; i < this.addtabledata.length; i++) {
      const currentCompareId = this.addtabledata[i].tempId ?? this.addtabledata[i].id;
      if (currentCompareId === compareId) {
        this.addtabledata[i].maxValue = num;
      }
    }
  }

  standardEvent(event: any, data: any, i: number): void {

    const compareId = data.tempId ?? data.id;

    for (let i = 0; i < this.addtabledata.length; i++) {
      const currentCompareId = this.addtabledata[i].tempId ?? this.addtabledata[i].id;
      if (currentCompareId === compareId) {
        this.addtabledata[i].standard = event.target.value;
      }
    }
  }

  getSessionData(): void {
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.user = this.baseApi.getUserSession();
  }

}
